export default __webpack_public_path__ + "static/media/social.93bca6db.jpg";